//Dependencias
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Componentes
import BannerFichas from '../../components/BannerFichas/BannerFichas';
import Navbar from '../../components/Navbar/Navbar';
import SessionBar from '../../components/SessionBar/SessionBar';
import Footer from '../../components/Footer/Footer';
import CardPerfil from '../../components/CardPerfil/CardPerfil';

//Funciones
import { fetchUserData } from '../../utils/api';

const Perfil = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    fetchUserData(navigate, setUserData);
  }, [navigate]);

  return (
    <div>
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 min-h-screen">
        <Navbar />
        {userData && <SessionBar />}
        <div className="flex flex-col flex-grow items-center justify-center text-center pb-10 mt-10 px-4">
          <CardPerfil />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Perfil;
